import baseApi from "@/lib/redux/api/baseApi";

export const googleIntegrationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getGoogleIntegrationStatus: builder.query({
      query: () => ({
        url: "/google/integration",
        method: "GET",
      }),
      providesTags: ["GoogleIntegration"],
    }),
    disconnectGoogleIntegration: builder.mutation({
      query: () => ({
        url: "/google/integration/disconnect",
        method: "DELETE",
      }),
      invalidatesTags: ["GoogleIntegration"],
    }),
    updateGoogleSyncEnabled: builder.mutation({
      query: (sync_enabled) => ({
        url: "/google/integration/sync-enabled",
        method: "PATCH",
        body: { sync_enabled },
      }),
      invalidatesTags: ["GoogleIntegration"],
    }),
    getGoogleCustomers: builder.query({
      query: () => ({
        url: "/google/customers",
        method: "GET",
      }),
    }),
    updateGoogleIntegrationCustomer: builder.mutation({
      query: (google_ads_customer_id) => ({
        url: "/google/integration/customer",
        method: "PATCH",
        body: { google_ads_customer_id },
      }),
      invalidatesTags: ["GoogleIntegration"],
    }),
    syncGoogleLeadsAuto: builder.mutation({
      query: () => ({
        url: "/google/sync-leads/auto",
        method: "POST",
      }),
      invalidatesTags: ["GoogleIntegration"],
    }),
    syncGoogleLeads: builder.mutation({
      query: (body = {}) => ({
        url: "/google/sync-leads",
        method: "POST",
        body,
      }),
      invalidatesTags: ["GoogleIntegration"],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetGoogleIntegrationStatusQuery,
  useDisconnectGoogleIntegrationMutation,
  useUpdateGoogleSyncEnabledMutation,
  useGetGoogleCustomersQuery,
  useUpdateGoogleIntegrationCustomerMutation,
  useSyncGoogleLeadsAutoMutation,
  useSyncGoogleLeadsMutation,
} = googleIntegrationApi;
